import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Skeleton, Tooltip } from 'antd'

import PublishButton from './../general/buttons/PublishButton'
import DeleteButton from './../general/buttons/DeleteButton'
import EditButton from './../general/buttons/EditButton'
import SearchButton from '../general/buttons/SearchButton'
import CopyLinkButton from './../general/buttons/CopyLinkButton'
import SaveButton from './../general/buttons/SaveButton'
import './../ui.style.scss'
import ButtonContainer from '../general/buttons/ButtonContainer'
import versionIcon from 'assets/images/version_icon.svg'
const width = ['100%', '100%']

class BucketDetailHeading extends React.Component {
  state = {
    loading: false,
    visible: false
  }

  showModal = () => {
    this.setState({
      visible: true
    })
  }

  render () {
    const { onClick, onAddSearch, deleteBucket, saveBucket, copyLink, editBucket, bucketName, bucketType, status, bucketId, isSaveEnable,
      showPublish, isDisableAddFilter, loading, isUpdateBlocked, isDeleteBlocked, isSelectionBlocking, handleShowHideBucketVersion,
      numberOfBucketVersions,
      showBucketActionButtons = true,
      isVersionOnlyMode,
      handleCopySchedule
    } = this.props

    let statusText = status
    if (typeof status === 'object') {
      statusText = status?.publishedText
    }

    return (
      <div className='bucket-detail-heading' onClick={onClick} >
        {isSelectionBlocking && <div className='overlay' />}
        {bucketName ? <>
          <div className='details'>
            <p className='bucket-heading'> {bucketName} </p>
            <Tooltip title={status?.publishedItemText || null} placement='top'>
              {
                !isVersionOnlyMode &&
                <p className='bucket-publish '>{ statusText } </p>
              }
            </Tooltip>
          </div>
          {
            !isVersionOnlyMode &&
            <div className='details'>
              <p className='bucket-type'> {bucketType} </p>
              {bucketId.length > 30 ? <ButtonContainer displayTitle={bucketId} childComponent={<p className='bucket-id'>{ `${bucketId}` } </p>} /> : <p className='bucket-id'>{ `${bucketId}` } </p> }
            </div>
          }

        </> : <Skeleton active title={false} paragraph={{ rows: 2, width: width }} loading />}
        {
          numberOfBucketVersions
            ? <div className='bucket-sub-heading'>
              <p>
              Scheduled Versions : {numberOfBucketVersions}
              </p>
            </div>
            : null
        }

        {showBucketActionButtons && (
          <div className='bottom-icons'>
            {
              !isVersionOnlyMode && (
                <ButtonContainer
                  displayTitle='Save'
                  childComponent={
                    <SaveButton
                      onClick={isSaveEnable ? saveBucket : () => {}}
                      isDisabled={!isSaveEnable || isUpdateBlocked}
                      isLoading={loading}
                    />
                  }
                />
              )
            }

            {
              isVersionOnlyMode &&
              <div
                className='black-button copy-version-button'
                onClick={handleCopySchedule}
              >
                <ButtonContainer
                  displayTitle='Copy Version'
                  childComponent={
                    <Icon
                      type='copy'
                      style={{ fontSize: '17px' }}
                      theme='filled'
                    />
                  }
                />
              </div>
            }

            <ButtonContainer
              displayTitle='Add Search Item'
              childComponent={
                <SearchButton
                  onClick={() => onAddSearch()}
                  isDisabled={isDisableAddFilter || isUpdateBlocked}
                />
              }
            />
            <ButtonContainer
              displayTitle='View API Response'
              childComponent={<CopyLinkButton onClick={copyLink} isDisabled={statusText === 'DRAFT'} />}
            />

            {!isVersionOnlyMode && (
              <ButtonContainer
                displayTitle='Remove'
                childComponent={
                  <DeleteButton onClick={deleteBucket} isDisabled={isDeleteBlocked} />
                }
              />
            )}

            <ButtonContainer
              displayTitle='Publish'
              childComponent={
                <PublishButton onClick={showPublish} isDisabled={isUpdateBlocked} />
              }
            />

            {!isVersionOnlyMode && (
              <>
                <ButtonContainer
                  displayTitle='Edit'
                  childComponent={
                    <EditButton onClick={editBucket} isDisabled={isUpdateBlocked || isSaveEnable} />
                  }
                />
                <ButtonContainer
                  displayTitle='Toggle Versions'
                  childComponent={
                    <button className='bucket-action-button' onClick={handleShowHideBucketVersion}>
                      <img src={versionIcon} />
                    </button>
                  }
                />
              </>
            )}
          </div>
        )}

      </div>
    )
  }
}

BucketDetailHeading.propTypes = {
  /** Check action of BucketDetailHeading. */
  onCheck: PropTypes.func,
  /** Handle Search action of BucketDetailHeading. */
  onHandleSearch: PropTypes.func,
  /** Bucket Name of BucketDetailHeading. */
  bucketName: PropTypes.string,
  /** Bucket Type of BucketDetailHeading. */
  bucketType: PropTypes.string,
  /** Publish Status BucketDetailHeading. */
  status: PropTypes.string,
  /** Bucket Id of BucketDetailHeading. */
  bucketId: PropTypes.string,
  /** Boolean for enable or disable save button */
  isSaveEnable: PropTypes.bool,
  /** Boolean for disable add filter in bucket */
  isDisableAddFilter: PropTypes.bool,
  /** Boolean for disabling delete */
  isDeleteBlocked: PropTypes.bool,
  /** Boolean for disabling update */
  isUpdateBlocked: PropTypes.bool
}

BucketDetailHeading.defaultProps = {
}

export default BucketDetailHeading
